import React from "react";
import { BrowserRouter, Route, Link } from "react-router-dom";
import Thumbnail from "./Thumbnail.js";
import "./App.css";
import usnThumb from "./assets/img/usn-thumbnail.jpg";
import dispatchThumb from "./assets/img/dispatch-thumbnail.jpg";
import vailThumb from "./assets/img/vail-thumbnail.jpg";
import coachellaThumb from "./assets/img/coachella-thumbnail.jpg";
import coalesseThumb from "./assets/img/coalesse-thumbnail.jpg";
import consensysThumb from "./assets/img/consensys-thumbnail.jpg";
import meritusThumb from "./assets/img/meritus-thumbnail.jpg";
import drumnowThumb from "./assets/img/drumnow-thumbnail.jpg";
import hexaThumb from "./assets/img/hexa-thumbnail.jpg";
import reelThumb from "./assets/img/reel-thumbnail.jpg";
import portfolioThumb from "./assets/img/portfolio-thumbnail.jpg";

import { motion } from "framer-motion";

const list = {
  visible: {
    opacity: 1,
    transition: { delayChildren: 0, staggerChildren: 0.2 },
  },
  hidden: { opacity: 0 },
};

const item = {
  visible: {
    opacity: 1,
    y: 0,
    transition: { ease: "easeOut", duration: 0.65 },
  },
  hidden: { opacity: 0, y: 15 },
};

function Work(props) {
  return (
    <div className="pageContainer">
      <motion.ul initial="hidden" animate="visible" variants={list}>
        <div className="intro-textContainer">
          <div className="intro-text">
          <h1>
            <div className="grayText">
              <motion.li variants={item}>I'm Nick. </motion.li>
            </div>
              <motion.li variants={item}>Founder and Principal </motion.li>
              <motion.li variants={item}>Designer at Opra Digital</motion.li>
            </h1>
          </div>
          <div className="intro-contact">
            <motion.li variants={item}>
              <p>
                Contact:{" "}
                <a href="mailto:nick@opra.design" className="line-link-sm">
                  nick@opra.design
                </a>
              </p>
            </motion.li>
            <motion.li variants={item}>
              <p>
                Website:{" "}
                <a href="https://opra.design" target="_blank" rel="noopener noreferrer" className="line-link-sm">
                  opra.design
                </a>
              </p>
            </motion.li>
          </div>
        </div>

      </motion.ul>
    </div>
  ); 
}

export default Work;
